import React, { Fragment } from 'react';
import { useImpactClaims } from 'hooks';
import ImpactClaimsSlider from './ImpactClaimSlider';
import ClaimModalContent from './ClaimModalContent';
import Modal from 'react-modal';
import styled from 'styled-components';
import { Check2Circle } from '@styled-icons/bootstrap/Check2Circle';
import Logo from 'images/seedtrace_logo_wordmark_black.svg';
import { useTranslation } from 'react-i18next';
import { useBrowser } from 'hooks';
const BACKGROUND_COLOR = '#F9F9F9';
const ClaimContainer = styled.div `
  background-color: ${BACKGROUND_COLOR};
  max-width: fit-content;
  border-radius: ${({ isMobile }) => (isMobile ? 0 : 8)}px;
  padding: ${({ isMobile }) => (isMobile ? '13px 0 4px' : '13px 10px 4px')};
  margin-bottom: 16px;
  font-family: Lato;
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '1000px',
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100vh - 80px)',
        backgroundColor: '#fff',
        border: 'none',
        padding: 0,
        overflow: 'visible',
        zIndex: 99999,
    },
};
const VerifiedWrapper = styled.div `
  top: 0;
  display: flex;
  align-items: center;
  margin-left: 17px;
`;
const VerifiedTitle = styled.h6 `
  font-size: 12px;
  margin: 0;
  font-weight: 300;
  margin: 0 6px;
`;
const LogoContainer = styled.div `
  svg {
    height: 12px;
  }
`;
const ImpactClaimsContainer = () => {
    const { selectedClaimId, handleCloseClaim, impactClaims } = useImpactClaims();
    const { t } = useTranslation();
    const { isMobile } = useBrowser();
    if (!impactClaims.edges.length)
        return null;
    return (React.createElement(Fragment, null,
        React.createElement(ClaimContainer, { isMobile: isMobile, id: "st-claims-container" },
            React.createElement(VerifiedWrapper, null,
                React.createElement(Check2Circle, { size: 16 }),
                React.createElement(VerifiedTitle, null, t('impact-claims.verified-with')),
                React.createElement(LogoContainer, null,
                    React.createElement(Logo, null))),
            React.createElement(ImpactClaimsSlider, { isMobile: isMobile, displayVerifiedText: true, backgroundColor: BACKGROUND_COLOR })),
        React.createElement(Modal, { isOpen: !!selectedClaimId, onRequestClose: handleCloseClaim, style: customStyles, contentLabel: "Impact Claims Overlay", overlayClassName: "st-modal-backdrop" },
            React.createElement(ClaimModalContent, { isMobile: isMobile }))));
};
export default ImpactClaimsContainer;
